import { ToastContainer } from 'react-toastify'
import { DivInput, InputStyle, Span } from '../Users/Users.style'
import { SearchIcon } from '../../assets/icons/search'
import { colors } from '../../theme'
import {
  Container,
  SpanIcon,
  FilterStatus,
  SpanFilter,
  Ul,
  Td,
} from '../../layouts/LayoutTable/LayoutTable'
import { FilterIcon } from '../../assets/icons/filter'
import { ItemFilter } from '../../components/ItemFilter/ItemFilter'
import { GenericTable } from '../../components/GenericTable/GenericTable'

import { Button } from '../../components/SideBar/Menu.style'
import { DivTitle } from '../../components/TitlePage/TitlePage'
import { Pagination } from '../../components/Pagination/Pagination'
import { Loading } from '../../components/Loading/Loading'
import { useProducts } from './useProducts'

export function Products() {
  const {
    searchValue,
    setSearchValue,
    isShowFilter,
    currentPage,
    setCurrentPage,
    products,
    fetchProducts,
    isLoading,
    handleKeyDown,
    goToPage,
    showFilter,
    statusChecked,
    statusCheckedTodos,
    setStatusCheckedFiltro,

    handleCheckboxChange,
  } = useProducts()

  return (
    <div>
      <ToastContainer theme="dark" />
      <DivTitle color="black" size={22}>
        Produtos
      </DivTitle>
      <Container>
        <DivInput>
          <InputStyle
            value={searchValue}
            onChange={event => setSearchValue(event.target.value)}
            onKeyDown={handleKeyDown}
            border={colors.grey300}
            placeholder="Pesquise uma palavra-chave"
            sizeX="264px"
            sizeY="42px"
          />
          <Span onClick={fetchProducts}>
            <SearchIcon />
          </Span>
          <SpanIcon onClick={showFilter}>
            <FilterIcon />
          </SpanIcon>
          <div>
            {isLoading ? (
              <Loading contrast={false} />
            ) : (
              <>
                <GenericTable
                  size="270px"
                  headers={['Produto', 'Status', 'Percentual']}
                  spacing="20px"
                  font="16px"
                >
                  {products.content &&
                    products.content.map(produto => (
                      <tr
                        onClick={() => goToPage(produto.id)}
                        className="itemTable"
                        key={produto.id}
                      >
                        {/* <td>{produto.id}</td> */}
                        <td className="col2">{produto.nome}</td>
                        <td className="col2">
                          <Td classification={produto.classificacao}>
                            {produto.classificacao
                              .replace('_', ' ')
                              .toLowerCase()}
                          </Td>
                        </td>
                        <td className="col3">
                          {String(produto.percentual).replace('.', ',')}%
                        </td>
                      </tr>
                    ))}
                </GenericTable>
                <Pagination
                  pageNumber={currentPage}
                  pageSize={products.totalElements}
                  offSet={products.size}
                  onClick={page => setCurrentPage(page)}
                />
              </>
            )}
          </div>
        </DivInput>

        {isShowFilter && (
          <FilterStatus>
            <SpanFilter>Filtrar por: </SpanFilter>

            <div>
              <Ul>
                <ItemFilter
                  top="2px"
                  checked={!statusCheckedTodos.includes('TODOS')}
                  onChange={() => {
                    // handleFiltroStatus(['Todos'])
                    handleCheckboxChange('TODOS')
                  }}
                  text="Todos"
                  id="all"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_ALTA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em alta'])
                    handleCheckboxChange('EM_ALTA')
                  }}
                  text="Em alta"
                  id="onHigh"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('EM_BAIXA')}
                  onChange={() => {
                    // handleFiltroStatus(['Em baixa'])
                    handleCheckboxChange('EM_BAIXA')
                  }}
                  text="Em baixa"
                  id="low"
                />
                <ItemFilter
                  top="2px"
                  checked={statusChecked.includes('NEUTRO')}
                  onChange={() => {
                    // handleFiltroStatus(['Neutro'])
                    handleCheckboxChange('NEUTRO')
                  }}
                  text="Neutro"
                  id="neutro"
                />
              </Ul>
            </div>
            <Button
              buttonType="SMALL"
              type="button"
              onClick={() => {
                setStatusCheckedFiltro(statusChecked)
                showFilter()
              }}
            >
              Aplicar
            </Button>
          </FilterStatus>
        )}
      </Container>
    </div>
  )
}
